export default __webpack_public_path__ + "static/media/logoSplashScreen.282575d9.jpg";